<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月14日 17:26:52 +0800
 * @最后修改时间: 2022-06-08 15:05:18
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\components\viewPropertyGroup.vue
 -->
<template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closePorpertyDialog"
    :title="$t('label_essweb_shift_form_dialog_viewPropertyLabel')"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row dense>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-select
              :items="RosterPropertyGroup"
              item-text="roster_property_group_name"
              item-value="uuid"
              dense
              disabled
              :placeholder="$t('label_essweb_RosterPropertyGroup_list_title')"
              v-model="RosterFormMasterData.roster_property_group_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            class="grey lighten-5 rounded-lg"
          >
            <PropertyList
              :items="desserts"
              :canView="false"
              :canEdit="false"
              :listdata="PropertyListData"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ViewPropertyGroup",
  props: ["group_uuid", "show"],
  computed: {
    ...mapGetters(["companyLang"]),
    RosterPropertyGroup() {
      return this.$getSelectTrans(
        this.RosterPropertyGroupData,
        "roster_property_group_name"
      );
    },
  },
  data() {
    return {
      RosterPropertyGroupData: [],
      RosterPropertyData: [],
      PropertyListData: null,
      RosterFormMasterData: {
        roster_property_group_uuid: "",
      },
      desserts: [],
    };
  },
  watch: {
    group_uuid(val) {
      if (val) {
        this.RosterFormMasterData.roster_property_group_uuid = val;
        this.getPorpertyList(val);
      }
    },
  },
  mounted() {
    if (this.group_uuid) {
      this.RosterFormMasterData.roster_property_group_uuid = this.group_uuid;
      this.getPorpertyList(this.group_uuid);
    }
    this.getPropertyType();
  },
  methods: {
    closePorpertyDialog: function () {
      this.$emit("closeDialog", false);
    },
    getPorpertyList: function (uuid) {
      const that = this;
      this.desserts = [];
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property",
        url: "/roster-property/get-list/",
        data: {
          roster_property_group_uuid: uuid,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    // getPropertyByUuid: function(uuid) {
    //   const that = this;
    //   this.RosterPropertyData = [];
    //   this.$Request({
    //     method: "POST",
    //     table: "ess_att_roster_property",
    //     url: "/roster-property/get-roster-property-list/",
    //     data: { roster_property_group_uuid: uuid },
    //   }).then((res) => {
    //     that.RosterPropertyData = res.data;
    //   });
    // },
    getPropertyType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_property_group",
        url: "/roster-property-group/get-list/",
      }).then((res) => {
        that.RosterPropertyGroupData = res.data;
      });
    },
  },
};
</script>
<style>
/* .v-data-table-header {
  background: grey;
  background-color: grey;
} */
</style>
